import * as React from 'react';
import { IJobSearchResult } from '../../../global/DTO/job-search';
import { IJobSearchPageContent } from '../../models/content';


interface IProps {
    result: IJobSearchResult;
    content: IJobSearchPageContent;
    onClick: (hitId) => void;
}

export class Result extends React.Component<IProps, any> {
    render() {
        var { result, onClick } = this.props;
        return this.renderDefault();
    }

    renderDefault = () => {
        var { result, onClick, content } = this.props;
        return (
            <li className="job-result">
                <div className="job-result-inner">
                    <div className="job-result-info">
                        <a href={result.detailPageUrl}><h4 className="accent underline" dangerouslySetInnerHTML={{ __html: result.title }} /></a>
                        <div className="job-result-details flex-fiftyfifty">
                            {result.businessArea && <p><strong className="extra-bold">{content.resultBusinessAreaLabelText}</strong> {result.businessArea}</p>}
                            {result.city && <p><strong className="extra-bold">{content.resultLocationLabelText}</strong> {result.city}, {result.city === result.state ? result.country : result.state}</p>}
                        </div>
                    </div>
                    {
                        result.linkUrl &&
                        <div className="job-result-cta">
                            <a className="btn-outline" href={result.linkUrl}>{content.resultLinkText}</a>
                        </div>
                    }
                </div>
            </li>
        )
    }

    renderDescription(description: string, shorten?: boolean) {
        return description;
    }
}